/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  PublishedContentCallerContext,
  PublishedContentCallerInput,
  PublishedContentCustomHomepage,
  PublishedContentCustomHomepageInput,
  PublishedContentPublishedSiteInput,
  PublishedContentRevisionMetaLinks,
  PublishedContentRevisionMetaLinksInput,
  PublishedContentRouting,
  PublishedContentRoutingInput,
  PublishedContentSiteBundle,
  PublishedContentSiteBundleInput,
  PublishedContentSiteEntry,
} from "./data-contracts";

/**
 * No description
 * @tags rpc, internal
 * @name GetPublishedContentRouting
 * @summary How a hostname maps to sites, for the edge.
 * @request POST:/rpc/published-content/routing
 * @secure
 */

// @ts-ignore
export const getPublishedContentRouting: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {
      "200": {
        maxAge: 86400;
        staleWhileRevalidate: 86400;
        transient: { maxAge: 300; staleWhileRevalidate: 86400 };
      };
    };
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: {
      procedure: "getRouting";
      endpoint: "published-content-routing";
      result: "cacheable";
    };
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PublishedContentRoutingInput;
  RequestHeaders: {};
  ResponseBody: PublishedContentRouting;
  ResponseStatusCode: 200;
} = {
  route: "/rpc/published-content/routing",
  method: "post",
  streaming: false,
  tags: ["rpc", "internal"],
  gateway: {
    cache: {
      "200": {
        maxAge: 86400,
        staleWhileRevalidate: 86400,
        transient: { maxAge: 300, staleWhileRevalidate: 86400 },
      },
    },
    edge: { mode: "none", data: [], rollout: null },
    rpc: {
      procedure: "getRouting",
      endpoint: "published-content-routing",
      result: "cacheable",
    },
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags rpc, internal
 * @name GetPublishedContentSiteBundle
 * @summary The site bundle used to resolve published content, for the edge.
 * @request POST:/rpc/published-content/site-bundle
 * @secure
 */

// @ts-ignore
export const getPublishedContentSiteBundle: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {
      "200": {
        maxAge: 86400;
        staleWhileRevalidate: 86400;
        transient: { maxAge: 300; staleWhileRevalidate: 86400 };
      };
    };
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: {
      procedure: "getSiteBundle";
      endpoint: "published-content-site-bundle";
      result: "cacheable";
    };
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PublishedContentSiteBundleInput;
  RequestHeaders: {};
  ResponseBody: PublishedContentSiteBundle;
  ResponseStatusCode: 200;
} = {
  route: "/rpc/published-content/site-bundle",
  method: "post",
  streaming: false,
  tags: ["rpc", "internal"],
  gateway: {
    cache: {
      "200": {
        maxAge: 86400,
        staleWhileRevalidate: 86400,
        transient: { maxAge: 300, staleWhileRevalidate: 86400 },
      },
    },
    edge: { mode: "none", data: [], rollout: null },
    rpc: {
      procedure: "getSiteBundle",
      endpoint: "published-content-site-bundle",
      result: "cacheable",
    },
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags rpc, internal
 * @name GetPublishedContentPublishedSite
 * @summary The published content of a site with what filtering it for a visitor needs, for the edge.
 * @request POST:/rpc/published-content/published-site
 * @secure
 */

// @ts-ignore
export const getPublishedContentPublishedSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: { "200": { maxAge: 86400; transient: { maxAge: 300 } } };
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: {
      procedure: "getPublishedSite";
      endpoint: "published-content-site";
      result: "cacheable";
    };
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PublishedContentPublishedSiteInput;
  RequestHeaders: {};
  ResponseBody: PublishedContentSiteEntry;
  ResponseStatusCode: 200;
} = {
  route: "/rpc/published-content/published-site",
  method: "post",
  streaming: false,
  tags: ["rpc", "internal"],
  gateway: {
    cache: { "200": { maxAge: 86400, transient: { maxAge: 300 } } },
    edge: { mode: "none", data: [], rollout: null },
    rpc: {
      procedure: "getPublishedSite",
      endpoint: "published-content-site",
      result: "cacheable",
    },
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags rpc, internal
 * @name GetPublishedContentCaller
 * @summary The caller of GitBook Open identified by its API token, for the edge.
 * @request POST:/rpc/published-content/caller
 * @secure
 */

// @ts-ignore
export const getPublishedContentCaller: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: { "200": { maxAge: 300 } };
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: {
      procedure: "getCallerContext";
      endpoint: "published-content-caller";
      result: "plain";
    };
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PublishedContentCallerInput;
  RequestHeaders: {};
  ResponseBody: PublishedContentCallerContext;
  ResponseStatusCode: 200;
} = {
  route: "/rpc/published-content/caller",
  method: "post",
  streaming: false,
  tags: ["rpc", "internal"],
  gateway: {
    cache: { "200": { maxAge: 300 } },
    edge: { mode: "none", data: [], rollout: null },
    rpc: {
      procedure: "getCallerContext",
      endpoint: "published-content-caller",
      result: "plain",
    },
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags rpc, internal
 * @name GetPublishedContentRevisionMetaLinks
 * @summary The meta links of every page in a revision, for the edge.
 * @request POST:/rpc/published-content/revision-meta-links
 * @secure
 */

// @ts-ignore
export const getPublishedContentRevisionMetaLinks: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: { "200": { maxAge: 86400; staleWhileRevalidate: 604800 } };
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: {
      procedure: "getRevisionMetaLinks";
      endpoint: "published-content-revision-meta-links";
      result: "cacheable";
    };
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PublishedContentRevisionMetaLinksInput;
  RequestHeaders: {};
  ResponseBody: PublishedContentRevisionMetaLinks;
  ResponseStatusCode: 200;
} = {
  route: "/rpc/published-content/revision-meta-links",
  method: "post",
  streaming: false,
  tags: ["rpc", "internal"],
  gateway: {
    cache: { "200": { maxAge: 86400, staleWhileRevalidate: 604800 } },
    edge: { mode: "none", data: [], rollout: null },
    rpc: {
      procedure: "getRevisionMetaLinks",
      endpoint: "published-content-revision-meta-links",
      result: "cacheable",
    },
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags rpc, internal
 * @name GetPublishedContentDraftSiteBundle
 * @summary The site bundle of a site in draft mode, used to resolve previews, for the edge.
 * @request POST:/rpc/published-content/draft-site-bundle
 * @secure
 */

// @ts-ignore
export const getPublishedContentDraftSiteBundle: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: { "200": { maxAge: 5; transient: { maxAge: 5 } } };
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: {
      procedure: "getDraftSiteBundle";
      endpoint: "published-content-draft-site-bundle";
      result: "cacheable";
    };
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PublishedContentSiteBundleInput;
  RequestHeaders: {};
  ResponseBody: PublishedContentSiteBundle;
  ResponseStatusCode: 200;
} = {
  route: "/rpc/published-content/draft-site-bundle",
  method: "post",
  streaming: false,
  tags: ["rpc", "internal"],
  gateway: {
    cache: { "200": { maxAge: 5, transient: { maxAge: 5 } } },
    edge: { mode: "none", data: [], rollout: null },
    rpc: {
      procedure: "getDraftSiteBundle",
      endpoint: "published-content-draft-site-bundle",
      result: "cacheable",
    },
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags rpc, internal
 * @name GetPublishedContentCustomHomepage
 * @summary The custom homepage path of a space revision as a content token sees it, for the edge.
 * @request POST:/rpc/published-content/custom-homepage
 * @secure
 */

// @ts-ignore
export const getPublishedContentCustomHomepage: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: { "200": { maxAge: 5 } };
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: {
      procedure: "getCustomHomepage";
      endpoint: "published-content-custom-homepage";
      result: "plain";
    };
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PublishedContentCustomHomepageInput;
  RequestHeaders: {};
  ResponseBody: PublishedContentCustomHomepage;
  ResponseStatusCode: 200;
} = {
  route: "/rpc/published-content/custom-homepage",
  method: "post",
  streaming: false,
  tags: ["rpc", "internal"],
  gateway: {
    cache: { "200": { maxAge: 5 } },
    edge: { mode: "none", data: [], rollout: null },
    rpc: {
      procedure: "getCustomHomepage",
      endpoint: "published-content-custom-homepage",
      result: "plain",
    },
  },
  criticalityLevel: "low",
  deprecated: false,
};
